import React, { useRef, useState } from 'react';

import { motion } from 'framer-motion';
import Options from './Options';
import SplashText from '../../buttonApp/SplashText';
import QuestionText from './QuestionText';
import { usePxToVw } from '../../../../hooks/usePxToVw';

function Question({
  question,
  dispatch,
  answer,
  triviaQuizSettings,
  numQuestions,
  index,
  setIsCorrect,
  brandFont,
  brandColor,
}) {
  const { pxToVw } = usePxToVw();

  return (
    <div>
      {/* Question Text with Slide-In Animation */}
      <motion.div
        key={question._id} // Ensures animation runs for each question
        initial={{ x: '-100vw', opacity: 0 }}
        animate={{ x: 0, opacity: 1 }}
        exit={{ x: '-100vw', opacity: 0 }}
        transition={{ ease: 'easeInOut', duration: 1 }}
        style={{
          display: 'flex',
          gap: '12px',
          width: pxToVw(triviaQuizSettings?.answerSettings?.width),
        }}
      >
        <QuestionText
          text={`${question.question}`}
          settings={triviaQuizSettings?.questionTextSettings}
          triviaQuizSettings={triviaQuizSettings}
          index={index}
        />
      </motion.div>

      {/* Options with a Delay of 2 Seconds */}

      <Options
        question={question}
        dispatch={dispatch}
        answer={answer}
        triviaQuizSettings={triviaQuizSettings}
        numQuestions={numQuestions}
        index={index}
        setIsCorrect={setIsCorrect}
        brandFont={brandFont}
        brandColor={brandColor}
      />
    </div>
  );
}

export default Question;
